import { render, staticRenderFns } from "./MagatzemDetail.vue?vue&type=template&id=10864584&scoped=true"
import script from "./MagatzemDetail.vue?vue&type=script&lang=js"
export * from "./MagatzemDetail.vue?vue&type=script&lang=js"
import style0 from "./MagatzemDetail.vue?vue&type=style&index=0&id=10864584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10864584",
  null
  
)

export default component.exports